import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { PageComponent } from "../page/page.component";
import { PageConfig } from '../models/page.interface';
import { SectionConfig } from '../models/section.interface';
import { ParserService } from '../services/parser.service';
import { PreParserService } from '../services/pre-parser.service';
import { ValidationService, ValidationType } from '../services/validation.service';
import { FormService } from './form.service';
import { BehaviorSubject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomMessageComponent } from '../../custom-message/custom-message.component';
import { RFFConstants } from '../constants';
import { LocalDBService } from '../../local-db.service';
import { LoaderService } from '../../shared/loader.service';
@Component({
  selector: 'app-dynamic-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class Form implements OnInit {
  formPreview = false;
  @ViewChild('disp') iframe: ElementRef;
  @ViewChild(PageComponent) form: PageComponent;
  @Input() title: string;
  @Input() message: string;
  @Input() actions: any;
  @Input() templateId: any;
  @Input() data: any;
  @Input() formEditable: any;
  constructor(
    private _parseService: ParserService,
    private _preParseService: PreParserService,
    private _validationService: ValidationService,
    private _formService: FormService,
    private _router: ActivatedRoute,
    private _route: Router,
    private modalService: NgbModal,
    private constants: RFFConstants,
    private _localDBService: LocalDBService,
    private _location: Location,
    private _loader: LoaderService
  ) { }

  pages: PageConfig[] = [];
  template: any = {
    "category": "inspection",
    "displayFields": ["name"],
    "name": "Sample template",
    "rFFSchema": {
      "layout": {},
      "schema": {},
      "styles": {},
      "validation": {}
    }
  };
  ngOnInit() {
    if (this._router.snapshot.params.id) {
      this.templateId = this._router.snapshot.params.id;
    }
    this._formService.getForm(this.templateId)
      .subscribe(
        (result: any) => {

          this.template = result.data.templateDetails

          // Temp
          const prefillContent = this._preParseService.parseForPrefillContent(this.template.rFFSchema)

          if (Object.keys(prefillContent).length > 0) {

            //Fetching Prefill Query data
            var prefillQueryData = this.fetchPrefillQueryContent(prefillContent);

            const queryData = prefillQueryData.queryData;
            const data = prefillQueryData.data;
            if (Object.keys(queryData).length > 0) {

              //Fetching Prefill Input data
              const self = this;
              this.fetchPrefillInputData(data, queryData, prefillContent, function (inputData) {
                self.data = Object.assign(data, self.data);

                self._formService.getAssets()
                  .subscribe(
                    (result: any) => {
                      if (result.data) {

                        var customData = {};
                        _.forEach(result.data, (value, key) => {
                          var optionsData = [];
                          _.forEach(value, (asset) => {

                            let option = {};
                            option[asset['_id']] = asset['name'];
                            optionsData.push(option);
                          });
                          customData[key] = optionsData;
                        })

                        self.pages = self._parseService.parseForm(self.template.rFFSchema, { data: self.data, error: {} }, inputData, customData);
                      } else {
                        self.pages = self._parseService.parseForm(self.template.rFFSchema, { data: self.data, error: {} }, inputData);
                      }
                    },
                    err => {
                      console.log(err);
                    }
                  );

              });
            } else {
              this.data = Object.assign(data, this.data);
              this.pages = this._parseService.parseForm(this.template.rFFSchema, { data: this.data, error: {} });
            }
          } else if (this.data && Object.keys(this.data).length > 0) {
            this.pages = this._parseService.parseForm(this.template.rFFSchema, { data: this.data, error: {} });
            if (this.pages) {
              if (this.formEditable) {
                this.showEditableForm();
              }
            }
          } else {
            this.pages = this._parseService.parseForm(this.template.rFFSchema);
          }
        },
        (err) => {
          console.log(err);
        });

    //Subscribing to ValidationService for Applyling Validation
    this.validationApplier();
  }

  preview() {
    var data = {};
    var errors = {};
    _.forEach(this.pages[0].sections, (section) => {
      if (section.value) {
        data[section.id] = section.value;
      }
      _.forEach(section.fields, (field) => {

        if (field.value) {
          data[field.id] = field.value;

          if (field.value[0] && field.value[0]['file']) {

            data[field.id] = _.map(field.value, (thumbObj) => {

              let thumbImageUrl = (thumbObj['thumb']).replace('data:image/png;base64,', '');
              thumbImageUrl = thumbImageUrl.replace('data:image/jpeg;base64,', '');

              return { thumbnail: thumbImageUrl };
            });

          } else if (field.value['additionalInfo'] && field.value['additionalInfo']['images'] && field.value['additionalInfo']['images'][0]) {

            const images = _.map(field.value['additionalInfo']['images'], (thumbObj) => {

              let thumbImageUrl = (thumbObj['thumb']).replace('data:image/png;base64,', '');
              thumbImageUrl = thumbImageUrl.replace('data:image/jpeg;base64,', '');

              return { thumbnail: thumbImageUrl };
            });

            const additionalInfo = { images: images, comments: field.value['additionalInfo']['comments'] };

            const fieldvalue = Object.assign({}, field.value);
            data[field.id] = fieldvalue;
            data[field.id]['additionalInfo'] = additionalInfo;
          }

        }
        // delete dynamic fields
        if (field.dynamic && Array.isArray(field.value) && field.value.length > 1) {
          let dummyVal = 0;
          let checkVar = field.value.length;
          for (var i = field.value.length - 1; i >= 0; i--) {
            if (!field.value[i]) {
              dummyVal += 1;
              field.value.splice(i, 1);
            }
          }
          if (dummyVal === checkVar) {
            field.value.push('');
          }
        }

        //Applying validation for all fields
        this._validationService.applyValidation(field, data, [ValidationType.isRequired, ValidationType.onChange]);
        if (field.errorMessage && field.style.visibility === true) {
          errors[field.id] = field.errorMessage;
        }
      });
    });

    if (Object.keys(errors).length > 0) {
      //TODO: Show alert to fill all the required fields

      this.showErrorAlert('Information!!', 'Please fill all the mandatory fields', ['Ok']);

      return;
    }
    this.showEditableForm();
  }
  showEditableForm() {
    _.forEach(this.pages[0].sections, (section) => {
      section.style.editability = false;
      _.forEach(section.fields, (field) => {
        field.style.editability = false;
      });
    });

    this.formPreview = true;
  }
  cancelForm() {
    this._location.back();
  }
  submit() {

    var data = {};
    var errors = {};
    var deficiencies = {
      count: 0
    };
    var thumbnails = [];
    var dynamicSectionKeys = [];
    var svgs = [];

    const templateId = this._router.snapshot.params.id;
    const formData: FormData = new FormData();

    _.forEach(this.pages[0].sections, (section) => {
      if (section.value) {
        data[section.id] = section.value;
      }

      if (section.dynamic === true) {

        dynamicSectionKeys.push(section.id);

        var sectionData = {};
        var sectionErrors = {};
        var sectionDeficiencies = 0;
        _.forEach(section.value, (fieldsData, index) => {
          const sectionFields = [...section.fields].map(item => ({ ...item }));
          _.forEach(section.fields, (field) => {
            field.value = fieldsData[field.id];
            field.id = field.id + '_' + index
          })
          this.createDataObj(sectionData, formData, section, thumbnails, svgs, sectionDeficiencies, sectionErrors);
          section.fields = sectionFields;
        })
      } else {
        this.createDataObj(data, formData, section, thumbnails, svgs, deficiencies, errors);
      }
    });

    if (Object.keys(errors).length > 0) {
      this.showErrorAlert('Information!!', 'Please fill all the mandatory fields', ['Ok']);
      return;
    }

    formData.append('data', JSON.stringify({ data: data, error: errors, deficiencies: deficiencies.count }));
    formData.append('template', JSON.stringify({ _id: templateId, name: this.template.name, displayFields: this.template.displayFields, category: this.template.category }));
    formData.append('thumbnails', JSON.stringify(thumbnails));
    formData.append('svgs', JSON.stringify(svgs));
    formData.append('dynamicSectionKeys', JSON.stringify(dynamicSectionKeys));

    var self = this;
    this._localDBService.getData(['inspectionId', 'inspectionCount'], function (inspectionDetails) {

      if (inspectionDetails) {
        const taskId = 'I-' + inspectionDetails.inspectionId + '-' + inspectionDetails.inspectionCount;
        formData.append('inspectionId', taskId);

        self.submitData(formData, inspectionDetails);
      }
    })
  }

  submitData(formData, inspectionDetails) {

    inspectionDetails.inspectionCount = (parseInt(inspectionDetails['inspectionCount']) + 1).toString();
    this._localDBService.updateInspectionDetails(inspectionDetails);

    var template = JSON.parse(formData.get('template'));
    if (template && template.category === 'incident') {
      if (template._id === 'fh_task_template:incidentform') {
        formData.append('status', 0);
      } else {
        var taskId = JSON.parse(formData.get('data')).data.incident.taskId;
        formData.append('taskId', taskId);
      }
    }

    this._formService.submitForm(formData)
      .subscribe(
        (res: any) => {
          this._loader.changeLoadingVisibility(true);
          setTimeout(() => {
            this._location.back();
            this._loader.changeLoadingVisibility(false);
          }, 1000)
        },
        err => {
          console.log(err);
        }
      );
  }

  cleanUpImageData(imagesData) {
    const images = [...imagesData].map(item => ({ ...item }));
    const imagesValue = _.map(imagesData, (imageObj) => {
      delete imageObj.thumb;
      delete imageObj.src;
      return imageObj
    })

    return { images, imagesValue }
  }

  createDataObj(data, formData: FormData, section, thumbnails, svgs, deficiencies, errors) {

    _.forEach(section.fields, (field) => {
      if (field.value) {

        let images = [];
        if (field.value[0] && field.value[0]['file']) {
          const imagesData = this.cleanUpImageData(field.value);
          images = imagesData.images;
          field.value = imagesData.imagesValue;
        } else if (field.value['additionalInfo'] && field.value['additionalInfo']['images'] && field.value['additionalInfo']['images'][0]) {

          const imagesData = this.cleanUpImageData(field.value['additionalInfo']['images']);
          images = imagesData.images;
          field.value['additionalInfo']['images'] = imagesData.imagesValue;
        }


        //fetching thumbnails and appending files to formdata
        if (images.length > 0) {

          const thumbData = this.fetchThumbnails(field.id, images);
          thumbnails.push(...thumbData.thumbnails);

          _.forIn(thumbData.formData, (value, key) => {
            formData.append(key, value);
          });
        }

        //Calculating hazards found
        if ((field.type === this.constants.RFF_ELEMENT_TYPE.Hazard || field.type === this.constants.RFF_ELEMENT_TYPE.HazardWithLabel || field.type === this.constants.RFF_ELEMENT_TYPE.Action) && field.value['data']) {
          deficiencies.count += 1;

          //fetching thumbnails and appending files to formdata
          if (field.value.data['fixedImages'] && field.value.data['fixedImages'].length > 0) {
            const fixedImagesImagesData = this.cleanUpImageData(field.value.data['fixedImages']);
            let fixedImages = fixedImagesImagesData.images;
            field.value.data['fixedImages'] = fixedImagesImagesData.imagesValue;
            if (fixedImages.length > 0) {

              const thumbData = this.fetchThumbnails(field.id + '_fixedImages', fixedImages);
              thumbnails.push(...thumbData.thumbnails);

              _.forIn(thumbData.formData, (value, key) => {
                formData.append(key, value);
              });
            }
          }

          if (field.value.data['hazardImages'] && field.value.data['hazardImages'].length > 0) {
            const hazardImagesImagesData = this.cleanUpImageData(field.value.data['hazardImages']);
            let hazardImages = hazardImagesImagesData.images;
            field.value.data['hazardImages'] = hazardImagesImagesData.imagesValue;
            if (hazardImages.length > 0) {

              const thumbData = this.fetchThumbnails(field.id + '_hazardImages', hazardImages);
              thumbnails.push(...thumbData.thumbnails);

              _.forIn(thumbData.formData, (value, key) => {
                formData.append(key, value);
              });
            }
          }
        }

        if (field.type === this.constants.RFF_ELEMENT_TYPE.FreeFormDraw) {

          const imageObj = { image: field.value.image, fieldname: field.id };
          svgs.push(imageObj)

          delete field.value.image;
        }

        //Assigning field value into data obj
        data[field.id] = field.value;
      }

      if (field.errorMessage && field.style.visibility === true) {
        errors[field.id] = field.errorMessage;
      }
    });
  }


  fetchThumbnails(fieldId, images) {

    const formData: any = {};
    var thumbnails = [];
    _.forEach(images, (imageAlbum, index) => {
      const file: File = imageAlbum['file'];
      const fileName = fieldId + '_' + index;

      formData[fileName] = file;

      let thumb = (imageAlbum['thumb']).replace('data:image/png;base64,', '');
      thumb = thumb.replace('data:image/jpeg;base64,', '');

      var thumbObj = { fieldKey: fieldId };
      thumbObj[fileName] = thumb;

      thumbnails.push(thumbObj);
    });

    return { formData, thumbnails };
  }

  goBack() {
    if (!this.formEditable)
      this.formPreview = !this.formPreview;
    _.forEach(this.pages[0].sections, (section) => {
      section.style.editability = true;
      _.forEach(section.fields, (field) => {
        field.style.editability = true;
      });
    });
  }

  validationApplier() {
    this._validationService.behaviourData.subscribe(behaviourData => {

      if (behaviourData && Object.keys(behaviourData).length > 0 && this.pages[0]) {

        _.forEach(this.pages[0].sections, (section) => {

          //Updating behaviour data to models
          _.forEach(section.fields, (field) => {

            if (behaviourData['data'] && behaviourData['data'][field.id] !== undefined) {

              let value = behaviourData['data'][field.id];
              if (field.type === 'date' && value === '') {
                value = new Date();
              }
              if ((field.type === "multiSelection" || field.type === "singleSelection") && typeof value == 'string' && value !== '') {
                value = JSON.parse(value);
              }
              field.value = value;
              this.form.pageGroup.get(field.id).setValue(value);
              this.form.pageGroup.updateValueAndValidity();
            }

            if (behaviourData['visibility'] && behaviourData['visibility'][field.id] !== undefined) {

              const value = behaviourData['visibility'][field.id];
              field.style.visibility = value;
              this.form.pageGroup.get(field.id).setValue(field.value);
            }

            if (behaviourData['editability'] && behaviourData['editability'][field.id] !== undefined) {

              const value = behaviourData['editability'][field.id];
              field.style.editability = value;
              this.form.pageGroup.get(field.id).setValue(field.value);
            }

            if (behaviourData['options'] && behaviourData['options'][field.id] !== undefined) {

              const options = behaviourData['options'][field.id];
              field.data = options;
              this.form.pageGroup.get(field.id).setValue(field.value);
            }

            if (behaviourData['background_color'] && behaviourData['background_color'][field.id] !== undefined) {

              const value = behaviourData['background_color'][field.id];
              field.style.background_color = value;
              this.form.pageGroup.get(field.id).setValue(field.value);
            }
            if (behaviourData['border_color'] && behaviourData['border_color'][field.id] !== undefined) {

              const value = behaviourData['border_color'][field.id];
              field.style.border_color = value;
              this.form.pageGroup.get(field.id).setValue(field.value);
            }
            if (behaviourData['border_thickness'] && behaviourData['border_thickness'][field.id] !== undefined) {

              const value = behaviourData['border_thickness'][field.id];
              field.style.border_thickness = value;
              this.form.pageGroup.get(field.id).setValue(field.value);
            }
            if (behaviourData['corner_radius'] && behaviourData['corner_radius'][field.id] !== undefined) {

              const value = behaviourData['corner_radius'][field.id];
              field.style.corner_radius = value;
              this.form.pageGroup.get(field.id).setValue(field.value);
            }

          })
        })
      }
    });
  }




  fetchPrefillQueryContent(prefillContent) {
    var data = {};
    var queryData = {};
    _.forIn(prefillContent, (fieldProps, fieldKey) => {
      //Applying prefill data
      if (fieldProps['default'] && fieldProps['default']['type']) {
        if (fieldProps['default']['type'] === 'custom') {
          data[fieldKey] = fieldProps['default']['value'];
        } else {
          const type: string = fieldProps['default']['type'];
          if (fieldProps['type'] === this.constants.RFF_ELEMENT_TYPE.ShortText || fieldProps['type'] === this.constants.RFF_ELEMENT_TYPE.LongText) {
            const query = type.split(':');
            var value = '';
            if (query[0] === '_fh_user') {
              value = localStorage.getItem('userName');
            } else if (query[0] === '_fh_team') {
              value = localStorage.getItem('teamName');
            }
            data[fieldKey] = value;
          } else if (fieldProps['type'] === this.constants.RFF_ELEMENT_TYPE.MultiChoiceList || fieldProps['type'] === this.constants.RFF_ELEMENT_TYPE.CheckBoxList || fieldProps['type'] === this.constants.RFF_ELEMENT_TYPE.ReadText) {
            const query = type.split('$$');

            queryData[fieldKey] = this.fetchPrefillContent(query);
          } else if (fieldProps['type'] === this.constants.RFF_ELEMENT_TYPE.UserList) {
            const query = type.split(':');

            query.push('team._id::' + localStorage.getItem('teamId'));
            queryData[fieldKey] = this.fetchPrefillContent(query);
          }
        }
      };
    });

    return { queryData, data };
  }

  fetchPrefillInputData(data, queryData, prefillContentData, callback) {
    var inputData = {};
    _.forIn(queryData, (queryDataObj, fieldKey) => {

      this._formService.query(queryDataObj)
        .subscribe(
          (result: any) => {
            console.log(result);
            var prefillContent = [];

            if (queryDataObj['type'] === '_fh_team_user_list') {
              result.data = result.data[0] ? result.data[0].users : [];
              _.map(result.data, (item) => {
                var finalItem = {};
                finalItem[item._id] = item.name;
                prefillContent.push(finalItem);
              })
              inputData[fieldKey] = prefillContent;
            } else {

              if (prefillContentData[fieldKey] && prefillContentData[fieldKey].type === 'label') {
                _.map(result.data, (item) => {
                  prefillContent.push(item[queryDataObj['attribute']]);
                })
                inputData[fieldKey] = prefillContent.join('\n -');
              } else {
                _.map(result.data, (item) => {
                  var finalItem = {};
                  finalItem[item._id] = item[queryDataObj['attribute']];
                  prefillContent.push(finalItem);
                })
                inputData[fieldKey] = prefillContent;
              }
            }



            if (Object.keys(queryData).length === Object.keys(inputData).length) {

              return callback(inputData);
            }
          },
          (err) => {
            console.log(err);
          });
    });
  }

  fetchPrefillContent(query: Array<string>) {
    var queryData: any = {};
    _.forEach(query, (element, index) => {
      const queryParams = ['type', 'attribute']
      if ((index === 0) || (index === 1)) {
        queryData[queryParams[index]] = element;
      } else {
        if (!queryData.filters) {
          queryData.filters = {};
        }
        const filters = element.split('::');
        queryData.filters[filters[0]] = filters[1];
      }
    });

    return queryData;
  }

  getFormResponse() {
    var data = {};
    var errors = {};
    _.forEach(this.pages[0].sections, (section) => {
      _.forEach(section.fields, (field) => {

        if (field.value) {
          data[field.id] = field.value;
        }
        if (field.errorMessage) {
          errors[field.id] = field.errorMessage;
        }
      });
    });

    return { data, errors };
  }
  showErrorAlert(title: string, message: string, actions: any) {
    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-small nested-modal',
    };
    const modalRef = this.modalService.open(
      CustomMessageComponent,
      modalOptions
    );

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.actions = actions;
  }
}



// WEBPACK FOOTER //
// ./src/app/rFF/form/form.component.ts